import { FC } from "react";

type LimitFunctionTableTableDataProps = {
  checked: boolean;
  bgColor?: string;
};

const LimitFunctionTableTableData: FC<LimitFunctionTableTableDataProps> = ({
  checked,
  bgColor,
}) => {
  return (
    <td
      className="text-center table-cell"
      style={{
        backgroundColor: bgColor,
      }}
    >
      {checked ? <i className="icon-Checked text-2xl" /> : <></>}
    </td>
  );
};
export default LimitFunctionTableTableData;
